/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { environment } from './environments/environment';
import { EnvProperties, EnvService } from './app/core/services/env.service';

async function loadEnvConfig(): Promise<EnvProperties> {
  const response = await fetch('/assets/env/env.properties.json');
  return response.json();
}

async function bootstrap(): Promise<void> {
  const envConfig = await loadEnvConfig();
  EnvService.initialize(envConfig);
  const envService = new EnvService(envConfig);

  if (environment.production) {
    enableProdMode();
  }

  const { AppModule } = await import('./app/app.module');

  platformBrowserDynamic([
    { provide: EnvService, useValue: envService },
  ])
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
}

bootstrap();
